import React from 'react';
import '../style/floatingFlag.scss'
var imgWidth, imgHeight;
var amplitude = 30;
var period = 2;
var frequency = 1;
var waveLength;
var v;
var cftX;
var cftA;
var fps = 40;
var interval = 1000 / fps;
var stop = false;
var timeNow = Date.now();
var timeLast = timeNow;
var delta = 0;
var distance = 0;
var canvasHeight, canvasWidth;
var ctx = null; var lastY = 0
var isLoaded = false;
var mainScale = 1;
var imageScale = 1;
class FloatingFlag extends React.Component {
  constructor(props) {
    super();
  }

  componentDidMount() {
    ctx = this.canvas.getContext('2d');
    this.drawFlag();
  }

  async drawFlag() {
    const imgUrlArr = ['https://static.web.sdo.com/xuezu/pic/20200820_Kill/pc_2nd/flag.jpg', 'https://static.web.sdo.com/xuezu/pic/20200820_Kill/pc_2nd/flag-logo.png', 'https://static.web.sdo.com/xuezu/pic/20200820_Kill/pc_2nd/flag-bg.jpg'];
    const imgArr = await this.loadAllImage(imgUrlArr);
    this.props.startLoading();
    var targetHeight = document.body.clientHeight;
    var targetWidth = document.body.clientWidth;
    imgWidth = Math.floor(imgArr[0].width);
    imgHeight = Math.floor(imgArr[0].height);
    var scale = Math.max((targetHeight / imgHeight), (targetWidth / imgWidth));
    canvasWidth = imgWidth;
    canvasHeight = imgHeight + amplitude * 2;
    this.canvas.width = canvasWidth;
    this.canvas.height = canvasHeight;
    this.canvas.style.transform = `translate3d(-50%,-50%,0) scale(${scale})`;

    waveLength = imgWidth / period;
    cftX = 2 * Math.PI / waveLength;
    cftA = amplitude / imgWidth;
    v = waveLength * frequency;
    this.tick(...imgArr);
  }

  loadAllImage(imageArr) {
    let imageLine = [];
    imageArr.forEach((url) => {
      imageLine.push(this.loadImage(url));
    });
    return Promise.all(imageLine)
      .then((res) => {
        return res;
      })
      .catch((e) => {
        console.log("load image error:" + e);
      });
  }

  loadImage(url) {
    return new Promise((resolve, reject) => {
      let image = new Image();
      image.crossOrigin = "";
      image.src = url;
      image.setAttribute("crossOrigin", "Anonymous");
      image.onload = () => {
        resolve(image);
      };
      image.onerror = (e) => {
        reject(e);
      };
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.totalPercent !== this.props.totalPercent && this.props.totalPercent === 100) {
      isLoaded = true;
    }
  }

  tick = (flagImg, flagLogo, flagbg) => {
    if (stop) {
      return false;
    }
    timeNow = Date.now();
    delta = timeNow - timeLast;
    if (delta > interval) {
      timeLast = timeNow;
      distance += (delta / 1000 * v);
      ctx.clearRect(0, 0, canvasWidth, canvasHeight)
      if (isLoaded && mainScale > 0) {
        mainScale -= delta / 1000;
        if (mainScale < 0) {
          mainScale = 0; fps = 200;
          interval = 1000 / fps;
        }
      }
      if (isLoaded && mainScale === 0 && imageScale !== 0.6) {
        imageScale -= 0.01;
        if (imageScale < 0.6) { imageScale = 0.6; stop = true; }
      }
      if (mainScale !== 0) {
        for (var x = 0; x < imgWidth; x++) {
          var y = cftA * x * (Math.sin(cftX * (x - distance)) * mainScale) + amplitude;
          var opacity = (x === 0 ? 0 : (y - lastY) * 0.5 * mainScale);
          try {
            ctx.drawImage(flagImg, x, 0, 1, imgHeight, x, y, 1, imgHeight);
            ctx.fillStyle = `rgba(255,255,255,${opacity})`
            ctx.fillRect(x, 0, 1, imgHeight);
            lastY = y;
          }
          catch (e) {
            // console.log(image)
          }
        }
      }
      else {
        var targetWidth = flagLogo.width * imageScale;
        var posX = (canvasWidth - targetWidth) / 2;
        // var posY = 300 * (1 - imageScale)
        ctx.drawImage(flagbg, 0, amplitude, flagbg.width, flagbg.height);
        ctx.drawImage(flagLogo, posX, 233 + amplitude, flagLogo.width * imageScale, flagLogo.height * imageScale);
        // ctx.drawImage(flagImg, 0, 0, imgWidth, imgHeight, posX, posY, targetWidth, imgHeight * imageScale);
      }
    }
    requestAnimationFrame(this.tick.bind(this, flagImg, flagLogo, flagbg));
  }

  render() {
    return (
      <canvas ref={(ref) => { this.canvas = ref; }}></canvas>
    )
  }
}
export default FloatingFlag;
